const time = {
  'time.absence.KRANK_MIT_ATTEST': 'KRmA – Sick with certificate',
  'time.absence.KRANK_OHNE_ATTEST': 'KRoA – Sick without certificate',
  'time.absence.FZT': 'FZT – Comp time off day',
  'time.absence.type': 'Type',
  'time.absence.from': 'From',
  'time.absence.to': 'To',
  'time.absence.workDays': 'Working days',
  'time.absence.notes': 'Remarks',
  'time.active': 'active',
  'time.office': 'Office',
  'time.homeOffice': 'Home office',
  'time.noEntries': 'No entries',
  'time.minutes': '{n} min',

  'dashboard.title': 'Dashboard',
  'dashboard.greeting': 'Hello, {name}',
  'dashboard.error': 'Error',
  'dashboard.workedOf': 'worked of {hours} h',
  'dashboard.remaining': '{hours} h remaining',
  'dashboard.targetReached': 'Target working time reached! +{hours}',
  'dashboard.checkOut': 'Check out',
  'dashboard.notCheckedIn': 'Not checked in',
  'dashboard.today': 'Today',
  'dashboard.since': 'Since {time}',
  'dashboard.noEntry': 'No entry',
  'dashboard.month': 'Month',
  'dashboard.toMonthView': 'Go to monthly overview',
  'dashboard.vacationOverview': 'Vacation overview',
  'dashboard.vacationHint': 'Details under “Vacation”',

  'entries.title': 'Time tracking',
  'entries.loadError': 'Could not load time entries.',
  'entries.saveError': 'The entry could not be saved.',
  'entries.confirmDelete': 'Really delete this entry?',
  'entries.ownTimes': 'My times',
  'entries.prevWeek': 'Previous week',
  'entries.currentWeek': 'Current week',
  'entries.nextWeek': 'Next week',
  'entries.formEdit': 'Edit entry',
  'entries.formAdd': 'Add working time',
  'entries.date': 'Date',
  'entries.start': 'Start',
  'entries.end': 'End',
  'entries.model': 'Work model',
  'entries.break': 'Break (min)',
  'entries.breakAuto': 'automatic',
  'entries.save': 'Save',
  'entries.add': 'Add',
  'entries.cancel': 'Cancel',
  'entries.notesOptional': 'Note (optional)',
  'entries.weekSum': 'Weekly total ({from} – {to})',
  'entries.daysInWeek': 'Working days this week',
  'entries.colBreak': 'Break',
  'entries.colWorked': 'Working time',
  'entries.colModel': 'Model',
  'entries.colNotes': 'Note',
  'entries.daySum': 'Daily total',

  'month.title': 'Monthly overview',
  'month.pdfTitle': 'Download monthly report as PDF',
  'month.pdfLoading': 'Generating…',
  'month.pdfFilename': 'Monthly_report_{year}_{month}.pdf',
  'month.totalWorked': 'Total working time',
  'month.workDays': 'Working days',
  'month.avgPerDay': 'Avg. per day',
  'month.colDate': 'Date',
  'month.colIn': 'In',
  'month.colOut': 'Out',
  'month.colBreak': 'Break',
  'month.colWorked': 'Working time',
  'month.colLocation': 'Location',
  'month.colNotes': 'Note',
  'month.homeOfficeShort': 'HO',
  'month.absencesTitle': 'Absences this month',

  'year.title': 'Yearly overview',
  'year.totalWorked': 'Total working time {year}',
  'year.days': '{n} days',
  'year.noEntries': 'No entries',
  'year.avgPerDay': 'Avg. {time} / day',
  'year.absencesTitle': 'Absences {year}',
  'year.m1': 'Jan', 'year.m2': 'Feb', 'year.m3': 'Mar', 'year.m4': 'Apr', 'year.m5': 'May', 'year.m6': 'Jun',
  'year.m7': 'Jul', 'year.m8': 'Aug', 'year.m9': 'Sep', 'year.m10': 'Oct', 'year.m11': 'Nov', 'year.m12': 'Dec',

  'alltime.title': 'Overall overview',
  'alltime.totalWorked': 'Total working time',
  'alltime.daysWorked': 'Days worked',
  'alltime.firstEntry': 'First entry',
  'alltime.lastEntry': 'Last entry',
  'alltime.avgPerDay': 'Average per day:',
  'alltime.noData': 'No data available.',
};

export default time;
